import download from '../../images/newDesign/downloadFile.svg';
import { StyledArchiveCard } from './ArchiveCard.styled';
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {TextTrim} from "../../ui/TextTrim";
import {FileSize} from "../../ui/FileSize";
import {IntlDate} from "../../ui/IntlDate";
import {ActionsButton} from "../../common/actions_button/ActionsButton";
import {useMemo} from "react";
import {isAdminSelector} from "../../store/auth/selectors";
import classNames from "classnames";

/**
 * @param {ArchiveFile} file
 * */
export function ArchiveCard({ file, onFileAction = (action) => void null }) {
    const { t } = useTranslation();
    const isAdmin = useSelector(isAdminSelector);

    const actions = useMemo(() => {
        const aa = [];
        if (file.Metadata.deleted !== 'true') {
            aa.push({ action: 'delete', label: t('archive.file_actions.delete') })
        }
        if (isAdmin && file.Metadata.deleted === 'true') {
            aa.push({ action: 'undelete', label: t('archive.file_actions.undelete') });
        }
        return aa;
    }, [isAdmin, file])

    return (
        <StyledArchiveCard>
            <div className={classNames('item bllink-text-tiny', { deleted: file.Metadata.deleted === 'true' })}>
                <div><TextTrim length={15}>{file.Metadata.displayname ?? 'Undefined'}</TextTrim></div>
                <div>{t(`archive.file_type.${file.Metadata.type ?? 'none'}`)}</div>
                <div><IntlDate>{file.LastModified}</IntlDate></div>
                <div>{file.Metadata.userid}</div>
                <div><FileSize>{file.Size}</FileSize></div>
                <button className='download' type="button" onClick={() => onFileAction('download')}>
                    <img src={download} />
                </button>
            </div>
            <div className="item-actions">
                <ActionsButton
                    actions={actions}
                    onAction={onFileAction}
                />
            </div>
        </StyledArchiveCard>
    )
}

export default ArchiveCard;
